<div class="d-flex justify-content-between">
  <app-search (emitSearchKeyword)="receiveSearchKeyword($event)"></app-search>
  <div class="d-flex">
    @if (isSuperAdmin) {
      <app-select
        [form]="deviceForm"
        [control]="deviceForm.controls['organizationId']"
        [controlName]="'organizationId'"
        [clearButton]="true"
        [filter]="true"
        [submitted]="submitted"
        [data]="organizations"
        [name]="'label'"
        [value]="'value'"
        [disabled]="!organizations.length"
        [placeholder]="
          organizations.length ? 'Select Organization' : 'Loading...'
        "
        [width]="'200px'"
        (emitSelectedValue)="receiveSelectedValue($event)"
        class="me-2 select-outline"
      ></app-select>
    }
    <app-select
      [form]="deviceForm"
      [control]="deviceForm.controls['limit']"
      [controlName]="'limit'"
      [filter]="false"
      [submitted]="submitted"
      [data]="limits"
      [name]="'label'"
      [value]="'value'"
      [width]="defaultLimitSelectWidth"
      (emitSelectedValue)="receiveSelectedValue($event)"
      class="me-2 select-outline"
    ></app-select>
    @if (isWriteAccessible) {
      <button
        type="button"
        class="btn btn-primary me-2"
        (click)="openUploadModal()"
        >
        <i class="fas fa-upload"></i> Upload
      </button>
    }
    @if (isWriteAccessible) {
      <button
        type="button"
        class="btn btn-primary"
        (click)="openAddEditDeviceModal()"
        >
        <i-bs name="plus"></i-bs> Add Device
      </button>
    }
  </div>
</div>

<div class="mt-3">
  <app-table
    [tableConfig]="tableConfig"
    [module]="'Check in module'"
    [loading]="loading"
    (onScrollToBottom)="scrollToBottom($event)"
    [notFoundMessage]="notFoundMessage"
    (sendEvent)="receiveEvent($event)"
    >
  </app-table>
</div>
